import React, { useState, useEffect, useLayoutEffect } from 'react';
import $ from 'jquery';
import 'jquery-validation';
import Lottie from 'react-lottie';
import animationData from '../checkmark-ok.json'
import { Loader } from '../utils/loader/Loader';
import './contactarea.scss';

type props = {}

export const ContactArea = (props: any) => {

    const [isOnline, setIsOnline] = useState(false);
    const [_stopped, setStopped] = useState(true);
    const [_visible, setVisible] = useState("none");
    const [isaGoodJob, setIsaGoodJob] = useState(false);
    

    const defaultOptions = {
        loop: false,
        autoplay: false,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    useEffect(() =>{

        setIsOnline(true);

        $('#contactForm').validate({
            rules: {
                name: {
                    required: true,
                    minlength: 2
                },
                subject: {
                    required: true,
                    minlength: 4
                },
                number: {
                    required: true,
                    minlength: 5
                },
                email: {
                    required: true,
                    email: true
                },
                message: {
                    required: true,
                    minlength: 20
                }
            },
            messages: {
                name: {
                    required: "come on, you have a name, don't you?",
                    minlength: "your name must consist of at least 2 characters"
                },
                subject: {
                    required: "come on, you have a subject, don't you?",
                    minlength: "your subject must consist of at least 4 characters"
                },
                number: {
                    required: "come on, you have a number, don't you?",
                    minlength: "your Number must consist of at least 5 characters"
                },
                email: {
                    required: "no email, no message"
                },
                message: {
                    required: "um...yea, you have to write something to send this form.",
                    minlength: "thats all? really?"
                }
            },
            submitHandler: function (form) {

                console.log('submit', form)
                let _name:string = $(form).find('input[name="name"]').val()?.toString() || '';
                let _email:string = $(form).find('input[name="email"]').val()?.toString() || '';
                let _subject:string = $(form).find('input[name="subject"]').val()?.toString() || '';
                let _message:string = $(form).find('textarea[name="message"]').val()?.toString() || '';

                const formData = new FormData();

                formData.append('_name', _name);
                formData.append('_email', _email);
                formData.append('_oggetto', _subject);
                formData.append('_message', _message);

                const options = {
                    method: 'POST',
                    body: formData,
                    // If you add this, upload won't work
                    // headers: {
                    //   'Content-Type': 'multipart/form-data',
                    // }
                };

                fetch(`portalemcwp/core/SendMail.ashx`, options)
                .then(response => response.json())
                .then(data => { 
                    console.log('fetch success') 
                    $('#contactForm, .contact-title').hide(() => {
                        setVisible("block");
                        setStopped(false);
                        setIsaGoodJob(true);
                    })
                } )
                .catch(error => { console.log('fetch error', error) } );

                
                
                
                
                // fetch(`pippo.json`)
                // .then(response => response.json())
                // .then(data => {
                    
                // })
            }
        })
    })

    if (isOnline === false) {
        return <Loader />;
    }
    else
        return <section className="contact-section">
            <div className="container">
                {/* <div className="d-none d-sm-block mb-5 pb-4"> */}
                <div className="d-sm-block mb-5 pb-4">
                    <div className="row">
                        <div className="col-12">
                            <h2 className="contact-title">Contattataci compilando il form</h2>
                        </div>
                        <div id="formContainer" className={`col-lg-8 ${!isaGoodJob ? "" : "goodJob"}`}>
                            <form className="form-contact contact_form" action="contact_process.php" method="post" id="contactForm" >
                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <input className="form-control valid" name="name" id="name" type="text"   placeholder="Enter your name"/>
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <input className="form-control valid" name="email" id="email" type="email"   placeholder="Email"/>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <input className="form-control" name="subject" id="subject" type="text"   placeholder="Enter Subject"/>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <textarea className="form-control w-100" name="message" id="message" placeholder=" Message"></textarea>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group mt-3">
                                    <button type="submit" className="button button-contactForm boxed-btn">Invia</button>
                                </div>
                            </form>
                            <Lottie style={{ display: _visible }} options={defaultOptions}
                                height={300}
                                width={300}
                                isStopped={_stopped}
                                isPaused={_stopped}
                            />
                            {/* <button onClick={() => setStopped(false)}>Play</button> */}
                        </div>
                        <div className="col-lg-3 offset-lg-1">
                            <div className="media contact-info">
                                <span className="contact-info__icon"><i className="ti-home"></i></span>
                                <div className="media-body">
                                    <h3>Milano, Italia</h3>
                                    <p>Corso di Porta Romana 68 - 20122</p>
                                </div>
                            </div>
                            <div className="media contact-info">
                                <span className="contact-info__icon"><i className="ti-tablet"></i></span>
                                <div className="media-body">
                                    <h3>+39 02 87330815</h3>
                                    <p>Da Lunedì a Venerdì dalle ore 8:00 alle ore 20:00</p>
                                </div>
                            </div>
                            <div className="media contact-info">
                                <span className="contact-info__icon"><i className="ti-email"></i></span>
                                <div className="media-body">
                                    <h3>customerservice@infrontfinace.com</h3>
                                    <p>Contattaci e saremo lieti di aiutarti.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
}